import React, { FunctionComponent } from 'react';
import { Helmet } from 'react-helmet';

import { Layout } from '../components';
import ApteekkihalytinTietosuoja from '../components/legal/ApteekkihalytinTietosuoja';
import { canonicalUrl } from '../utils/canonicalUrl';

const PAGE_PATH = '/apteekkihalytin-tietosuoja';

const ApteekkihalytinTietosuojaPage: FunctionComponent = () => (
  <>
    <Helmet>
      <title>Apteekkihälyttimen tietosuojaseloste | Treet</title>
      <meta
        name="description"
        content="Apteekkihälytin-sovelluksen tietosuojaseloste. Seloste on tarkoitettu sovelluskauppojen ja sovelluksen linkeille."
      />
      <meta name="robots" content="noindex, nofollow" />
      <link rel="canonical" href={canonicalUrl(PAGE_PATH)} />
    </Helmet>
    <Layout>
      <ApteekkihalytinTietosuoja />
    </Layout>
  </>
);

ApteekkihalytinTietosuojaPage.displayName = 'ApteekkihalytinTietosuojaPage';

export default ApteekkihalytinTietosuojaPage;
